import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import ProstoHeader from "@/prosto/ProstoHeader";
import ProstoAppRow from "@/prosto/ProstoAppRow";

export default function ProstoCategory() {
  const { name } = useParams();
  const [apps, setApps] = useState(null);
  const cat = decodeURIComponent(name || "");

  useEffect(() => {
    api.apps({ category: cat }).then(setApps).catch(() => setApps([]));
  }, [cat]);

  return (
    <div className="pb-20">
      <ProstoHeader title={cat} back />
      <div className="px-4 pt-2">
        {apps === null ? (
          <div className="py-10 text-center text-slate-400">Загрузка…</div>
        ) : apps.length === 0 ? (
          <div className="py-10 text-center text-slate-400">В этой категории пока пусто.</div>
        ) : (
          <div className="divide-y divide-slate-100">
            {apps.map((app) => (
              <ProstoAppRow key={app.id} app={app} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
